import { FC, PropsWithChildren } from "react";
import styles from "./DrawerNavCard.module.scss";
import { DrawerNavCardProps } from "./DrawerNavCard.props";
import classNames from "classnames";
import { NavContext } from "../NavContext";

/**
 * Indicates that the child navigation card be styled as a drawer nav card.
 */
export const DrawerNavCard: FC<PropsWithChildren<DrawerNavCardProps>> = (props: PropsWithChildren<DrawerNavCardProps>) => {
  const { children, color, expanded } = props;

  const navCardClasses = classNames(styles.drawerNavCard, color, "drawer-nav-card", {
    expanded: expanded === true,
    contracted: expanded === false,
  });

  return (
    <NavContext.Provider value="drawer">
      <div className={navCardClasses}>{children}</div>
    </NavContext.Provider>
  );
};
